import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select, Spin, TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import { GetDesignationsApi } from "../../../api/GetDesignationsApi";
import GetReportersApi from "../../../api/GetReportersApi";
import { GetTreeSelectUnitsApi } from "../../../api/GetTreeSelectUnitsApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { GetUserRoleApi } from "../../../api/user-role/GetUserRoleApi";
import AddPositionsApi from "../../../api/positions/AddPositionApi";

const { Option } = Select;

function AddPositionModal(props) {
  const [submit, setSubmit] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [unitsTree, setUnitsTree] = useState([]);
  const [reporters, setReporters] = useState([]);
  const [roles, setRoles] = useState([]);
  const [newRoles, setNewRoles] = useState([]);
  const [topUnitSelected, setTopUnitSelected] = useState(false);

  function handleCancel() {
    setSubmit(false);
    setDesignations([]);
    setUnitsTree([]);
    setReporters([]);
    props.handleCancel();
    setTopUnitSelected(false);
  }

  useEffect(() => {
    if (props.visible) {
      getDesignations();
      getUnitsTree();
      getRole();
    }
  }, [props.visible]);

  async function getDesignations() {
    const apiResponse = await GetDesignationsApi();
    if (apiResponse.message === "success") {
      setDesignations(apiResponse.designations);
    }
  }

  async function getUnitsTree() {
    const apiResponse = await GetTreeSelectUnitsApi();
    if (apiResponse.message === "success") {
      setUnitsTree(apiResponse.units);
    }
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await AddPositionsApi(
      null,
      values.designation || null,
      values.unit,
      values.userRoleId || null
    );
    console.log(apiResponse);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add position try again later."
      );
    }
    handleCancel();
  }

  async function unitSelected(value) {
    findRoles(value);
    const apiResponse = await GetReportersApi(value);
    if (apiResponse.message === "success") {
      setReporters(apiResponse.users);
    }
  }

  async function getRole() {
    const apiResponse = await GetUserRoleApi();
    if (apiResponse.success) {
      setRoles(apiResponse.data);
      const roleArray = apiResponse.data.filter(
        (role) => role.name !== "Super-Admin"
      );
      setNewRoles(roleArray);
    }
  }

  function findRoles(value) {
    value === unitsTree[0].id
      ? setTopUnitSelected(true)
      : setTopUnitSelected(false);
  }

  return (
    <Modal
      title="Add new position"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addPosition"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Unit*"
          name="unit"
          rules={[
            {
              required: true,
              message: "Please select a unit!",
            },
          ]}
        >
          <TreeSelect
            showSearch
            treeLine={true}
            dropdownStyle={{
              maxHeight: 400,
              overflow: "auto",
            }}
            treeData={unitsTree}
            placeholder="Select unit"
            treeDefaultExpandAll
            treeNodeFilterProp={"title"}
            showIcon={false}
            filterTreeNode
            onChange={(value) => {
              unitSelected(value);
            }}
          />
        </Form.Item>

        <Form.Item
          label="Designation*"
          name="designation"
          rules={[
            {
              required: true,
              message: "Please select a designation!",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select designation"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {designations.map((designation) => {
              return (
                <Option key={designation.id} value={designation.id}>
                  {designation.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          label="Role*"
          name="userRoleId"
          rules={[
            {
              required: true,
              message: "Please select a role!",
            },
          ]}
        >
          <Select
            placeholder="Select Role"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {topUnitSelected
              ? roles?.map((typ) => {
                  return (
                    <Option key={typ.id} value={typ.id}>
                      {typ.name}
                    </Option>
                  );
                })
              : newRoles?.map((typ) => {
                  return (
                    <Option key={typ.id} value={typ.id}>
                      {typ.name}
                    </Option>
                  );
                })}
          </Select>
        </Form.Item>

        {/* {!!reporters?.length && (
          <Form.Item label="Reporting to" name="reportingTo">
            <Select
              showSearch
              placeholder="Select reporter"
              optionFilterProp="children"
            >
              {reporters.map((reporter) => {
                return (
                  <Option key={reporter.id} value={reporter.id}>
                    {reporter.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        )} */}

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-32"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPositionModal;
